import { Copy } from "@/components/common/Copy";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@patient-watch/ui/tooltip";

function shortenId(id: string): string {
    const trimmed = id.trim();
    if (trimmed.length <= 8) return trimmed;
    return trimmed.slice(0, 8);
}

interface AdminCopyCellProps {
    value: string;
    /** Prefix for copy store id uniqueness. */
    idPrefix?: string;
}

/** Short UUID + copy affordance (RawData diary_id pattern). */
export function AdminCopyCell({ value, idPrefix = "admin-id" }: AdminCopyCellProps) {
    const full = value.trim();
    if (!full) {
        return <span className="block px-2 py-1 min-h-8" aria-hidden />;
    }

    const copyId = `${idPrefix}-${full}`;

    return (
        <div className="px-1 py-0.5 min-h-8">
            <TooltipProvider delayDuration={300}>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <span className="inline-flex">
                            <Copy id={copyId} value={full} className="items-center">
                                <span className="font-mono tabular-nums text-muted-foreground text-xs tracking-tight">
                                    {shortenId(full)}
                                </span>
                            </Copy>
                        </span>
                    </TooltipTrigger>
                    <TooltipContent side="top" className="max-w-xs font-mono text-xs break-all">
                        {full}
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}
